import React from 'react';
import type { LegalBlock } from '../types/content';
import { renderRich } from '../utils/richText';
import { RichList } from './RichList';
export function LegalBlocks({
  blocks
}: {
  blocks: LegalBlock[];
}) {
  return <div className="max-w-[860px]" data-id="element-65" data-mp="2srjdg0njcdjh">
      {blocks.map(block => <div key={block.title} data-id="element-66" data-mp="2wr9yrouam1gm">
          <h3 className="mb-2 mt-7 text-[17px] font-bold tracking-[-0.01em] text-fg" data-id="element-67" data-mp="2wsl4hu7atjad">{block.title}</h3>
          {block.paragraphs?.map(p => <p key={p} className="mb-3.5 text-[14.8px] leading-relaxed text-body" data-id="element-68" data-mp="3pgh7thrdi9g4">
              {renderRich(p)}
            </p>)}
          {block.items && <RichList items={block.items} className="text-[14.8px]" data-id="element-69" data-mp="3bokkrs4kapql" />}
        </div>)}
    </div>;
}